module.exports = __webpack_public_path__ + "static/img/img_yinsi.45c04819.png";